/**
 * Outillage des énumérations partagées.
 *
 * Le schéma SQL (`db/migrations`) fait foi : chaque énumération de ce paquet
 * reprend mot pour mot une contrainte `CHECK (… IN (…))` ou un jeu de codes
 * pré-chargés par les seeds. Le test `sql-parite.test.ts` relit les migrations et
 * échoue si une valeur diverge — c'est ce qui rend ce paquet fiable comme source
 * unique de vérité front/back.
 */
/**
 * Liste figée des valeurs d'une énumération, dans l'ordre de déclaration.
 * Utile pour peupler un `<select>`, un DTO `class-validator` ou un test.
 */
export function valeurs(source) {
    return Object.freeze(Object.values(source));
}
/**
 * Garde de type : vérifie qu'une valeur reçue de l'extérieur (formulaire, JSON,
 * ligne de base) appartient bien à l'énumération.
 */
export function estValeurDe(source, candidat) {
    return (typeof candidat === 'string' && Object.values(source).includes(candidat));
}
//# sourceMappingURL=enumeration.js.map